import { setImageLoading, setIdle } from "../../store/common/appStateSlice";
import {
  fetchUnsplashCollections,
  fetchUnsplashPhotos,
} from "../../api/unsplash";
import {
  setCollections,
  setImages,
  setTotal,
} from "../../store/media/mediaSlice";
import { PIXABAY_COLLECTIONS } from "../../constants/imageServices";
import { fetchPixabayPhotos } from "../../api/pixabay";
import { fetchPexelsCollections, fetchPexelsPhotos } from "../../api/pexels";
import { wrapPexelsImages, wrapPixabayImages } from "../../utils";

// export const loadUnsplashCollections = () => async (dispatch) => {
//   try {
//     dispatch(setImageLoading());
//     const data = await fetchUnsplashCollections();
//     dispatch(setCollections(data));
//     console.log(data[0]);
//     const photos = await fetchUnsplashPhotos(data[0].id);
//     dispatch(setImages(photos));
//     dispatch(setIdle());
//   } catch (error) {
//     console.error("Error loading unsplash collections", error);
//     // Handle the error state appropriately, e.g., setting an error state in your store
//     dispatch(setIdle());
//   }
// };

// export const loadUnsplashCollections = () => async (dispatch) => {
//   try {
//     dispatch(setImageLoading());
//     const data = await fetchUnsplashCollections();
//     const nonEmptyCollections = data.filter(collection => collection.total_photos > 0);
//     dispatch(setCollections(nonEmptyCollections));
//     if (nonEmptyCollections.length > 0) {
//       const photos = await fetchUnsplashPhotos(nonEmptyCollections[0].id);
//       dispatch(setImages(photos));
//     }
//     dispatch(setIdle());
//   } catch (error) {
//     console.error("Error loading Unsplash collections", error);
//     dispatch(setIdle());
//   }
// };
// export const loadUnsplashCollections = () => async (dispatch) => {
//   try {
//     dispatch(setImageLoading());
//     const data = await fetchUnsplashCollections();

//     // Filter out collections where user's username is not equal to "unsplashplus"
//     const filteredCollections = data.filter(collection => collection.user.username !== "unsplashplus");

//     // Log the filtered collections
//     console.log("Filtered collections:", filteredCollections);

//     // Set filtered collections to the store
//     dispatch(setCollections(filteredCollections));

//     // If there are filtered collections, fetch and set images for the first collection
//     if (filteredCollections.length > 0) {
//       const photos = await fetchUnsplashPhotos(filteredCollections[0].id);
//       dispatch(setImages(photos));
//     }

//     // Set idle state
//     dispatch(setIdle());
//   } catch (error) {
//     console.error("Error loading Unsplash collections", error);
//     dispatch(setIdle());
//   }
// };
export const loadUnsplashCollections = () => async (dispatch) => {
  try {
    dispatch(setImageLoading());
    const data = await fetchUnsplashCollections();

    // Filter out collections where user's username is not equal to "unsplashplus"
    const filteredCollections = data.filter((collection) => {
      return (
        collection.user.username !== "unsplashplus" &&
        collection.title !== "Tattoo Portraits" &&
        collection.title !== "Ramadan"
      );
    });

    // console.log("Filtered collections UNSPLASH:", filteredCollections);

    dispatch(setCollections(filteredCollections));

    if (filteredCollections.length > 0) {
      const photos = await fetchUnsplashPhotos(filteredCollections[0].id);
      dispatch(setImages(photos));
    }

    // Set idle state
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading Unsplash collections", error);
    dispatch(setIdle());
  }
};

export const loadUnsplashPhotos =
  (search, page, orientation) => async (dispatch, getState) => {
    try {
      const { images = [] } = getState().media;
      dispatch(setImageLoading());
      const data = await fetchUnsplashPhotos(search, page, orientation);
      dispatch(
        setImages(
          page === 1
            ? [...(data.results || [])]
            : [...images, ...(data.results || [])]
        )
      );
      dispatch(setTotal(data.total));
      dispatch(setIdle());
    } catch (error) {
      console.error("Error loading Unsplash collections", error);
      dispatch(setIdle());
    }
  };
export const loadPixabayCollections = () => async (dispatch) => {
  try {
    dispatch(setImageLoading());
    dispatch(setCollections(PIXABAY_COLLECTIONS));
    const photos = wrapPixabayImages(
      await fetchPixabayPhotos(PIXABAY_COLLECTIONS[0])
    );
    // console.log("Filtered collections PIXABAY:", photos);
    dispatch(setImages(photos));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading Pixabay collections", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};

export const loadPixabayPhotos =
  (search, page, orientation) => async (dispatch, getState) => {
    try {
      dispatch(setImageLoading());
      const { images = [] } = getState().media;
      const photos = await fetchPixabayPhotos(search, page, orientation);
      const formattedPhotos = wrapPixabayImages(photos.hits || []);
      dispatch(
        setImages(
          page === 1
            ? [...(formattedPhotos || [])]
            : [...images, ...(formattedPhotos || [])]
        )
      );
      dispatch(setTotal(photos.total));
      dispatch(setIdle());
    } catch (error) {
      console.error("Error loading Pixabay collections", error);
      // Handle the error state appropriately, e.g., setting an error state in your store
      dispatch(setIdle());
    }
  };

export const loadPexelsCollections = () => async (dispatch) => {
  try {
    dispatch(setImageLoading());
    const data = await fetchPexelsCollections();
    dispatch(setCollections(data.collections));
    const photos = wrapPexelsImages(
      await fetchPexelsPhotos(data.collections[0].id)
    );
    dispatch(setImages(photos));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading Pexels collections", error);
    dispatch(setIdle());
  }
};

export const loadPexelsPhotos =
  (search, page, orientation) => async (dispatch, getState) => {
    try {
      const { images = [] } = getState().media;
      dispatch(setImageLoading());
      const photos = await fetchPexelsPhotos(search, page, orientation);

      const formattedPhotos = wrapPexelsImages(photos?.photos || []);
      dispatch(
        setImages(
          page === 1
            ? [...(formattedPhotos || [])]
            : [...images, ...(formattedPhotos || [])]
        )
      );
      dispatch(setTotal(photos.total_results));
      dispatch(setIdle());
    } catch (error) {
      console.error("Error loading Pexels collections", error);
      // Handle the error state appropriately, e.g., setting an error state in your store
      dispatch(setIdle());
    }
  };
